/**
 * Human-readable product name. Single source of truth for UI headers, service
 * identifiers in health payloads and log prefixes.
 */
export const APP_NAME = "Ayet Agent Platform";
